var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"ngl_viewport",attrs:{"id":_vm.viewportId}})
}
var staticRenderFns = []

export { render, staticRenderFns }